import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useState , useEffect} from "react";
import Articalservice from "../../service/Articalservice";
import "./style/article.css";

const Article = () => {
	const [data, setData] = useState([]);
	
	useEffect(() => {
	  getData();
	}, []);
  
	const getData = async () => {
	  try {
		const response = await Articalservice.getAllInfo();
		const newData = response.docs.map((doc) => doc.data()); // Extract data from each document
		setData(newData);
	  } catch (error) {
		console.error("Error fetching data:", error);
	  }
	};
	

	return (
		<React.Fragment>
			{data.map((article, index) => (
			<div className="article">
			

				<div className="article-left-side">
					<div className="article-date">{article.date}</div>
				</div>

				<Link to="#">
					<div className="article-right-side">
						<div className="article-title">{article.title}</div>
						<div className="article-description">{article.description}</div>
						<div className="article-link">
							Read Article{" "}
							<FontAwesomeIcon
								style={{ fontSize: "10px" }}
								icon={faChevronRight}
							/>
						</div>
					</div>
				</Link>
		
			</div>
				))}
		</React.Fragment>
	);
};

export default Article;
